var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":"theme_primary","dark":"","extension-height":"36","height":"36","flat":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){return _vm.drawerToggle()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.drawerIcon()))])],1),(_vm.companyAccount && !_vm.loading)?_c('v-layout',{attrs:{"align-center":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("account_balance")]),_c('v-breadcrumbs',{attrs:{"items":[
          {
            exact: true,
            text: _vm.companyAccount
              ? _vm.companyAccount.company && _vm.companyAccount.company.isSupplier
                ? 'Supplier Accounts'
                : 'Customers Accounts'
              : 'Companies Accounts',
            disabled: false,
            to: _vm.companyAccount
              ? _vm.companyAccount.company && _vm.companyAccount.company.isSupplier
                ? '/company_accounts/suppliers_accounts'
                : '/company_accounts/customers_accounts'
              : '/company_accounts',
          },
          {
            exact: true,
            text: _vm.companyAccount && _vm.companyAccount.company_name,
            disabled: !(
              _vm.companyAccount &&
              _vm.companyAccount.company &&
              _vm.companyAccount.company.id
            ),
            to:
              '/companies/' +
              (_vm.companyAccount &&
                _vm.companyAccount.company &&
                _vm.companyAccount.company.id),
          } ],"dark":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("chevron_right")])]},proxy:true}],null,false,1743738863)}),_c('v-icon',[_vm._v("chevron_right")]),_c('span',{staticClass:"breadcrumb_current_page white--text"},[_vm._v(_vm._s(_vm.companyAccount && _vm.companyAccount.currency.code))]),_c('v-spacer'),_c('headerProfile')],1):_vm._e()],1),_c('v-container',{staticClass:"pt-2",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[(!_vm.loading)?_c('v-card',{attrs:{"max-width":"1280","width":"100%","flat":""}},[_c('companyAccountShow',{attrs:{"companyBalance":_vm.companyAccount,"accountAmount":0}})],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }